var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m8.512 4.137 4.797 4.797c0.281 0.281 0.441 0.668 0.441 1.066s-0.16 0.785 -0.441 1.066L8.512 15.863c-0.25 0.25 -0.586 0.387 -0.938 0.387 -0.73 0 -1.324 -0.594 -1.324 -1.324V12.5H1.25c-0.691 0 -1.25 -0.559 -1.25 -1.25v-2.5c0 -0.691 0.559 -1.25 1.25 -1.25h5v-2.426c0 -0.73 0.594 -1.324 1.324 -1.324 0.352 0 0.688 0.141 0.938 0.387zM13.75 16.25h2.5c0.691 0 1.25 -0.559 1.25 -1.25V5c0 -0.691 -0.559 -1.25 -1.25 -1.25h-2.5c-0.691 0 -1.25 -0.559 -1.25 -1.25s0.559 -1.25 1.25 -1.25h2.5c2.07 0 3.75 1.68 3.75 3.75v10c0 2.07 -1.68 3.75 -3.75 3.75h-2.5c-0.691 0 -1.25 -0.559 -1.25 -1.25s0.559 -1.25 1.25 -1.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/signin.475e8661a54f4751047a5cdf4b0cd8e0.svg";
export { ForwardRef as ReactComponent };